import { PEOPLE_DIRECTORY_PATH, STAFF_DIRECTORY_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const staffDirectoryRoute = createGlobalRoute({
  exact: true,
  name: STAFF_DIRECTORY_PAGE,
  path: `${PEOPLE_DIRECTORY_PATH}/:search(search)?`,
  subproduct: 'townsquare-people-team-directory',
});
